import React from 'react';
import styled from 'styled-components';
import { IDsiReportState } from '../../../data/providers/reports/dsiReportProvider';
import { Column } from '../../layout/Column';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import { Notable } from '../../shared/pdf/Notable';
import { EPdfMode, isPdf, shouldInvert } from '../../shared/pdf/Pdf';
import { DsiGraph } from './DSIGraph';

interface IProps {
  reportState: IDsiReportState;
  pdfMode?: EPdfMode;
}

export const DsiGraphCard = (props: IProps): React.ReactElement => {
  return (
    <PdfCardWrapper className='avoid-break' pdf={isPdf(props.pdfMode)}>
      <Notable pdf={isPdf(props.pdfMode)}>
        <Card inverse={shouldInvert(props.pdfMode)}>
          <Column>
            <CardBody withoutFooter>
              <DsiGraph
                results={props.reportState.resultList}
                pdfMode={props.pdfMode}
              />
            </CardBody>
          </Column>
        </Card>
      </Notable>
    </PdfCardWrapper>
  );
};

const PdfCardWrapper = styled.div<{ pdf?: boolean }>`
  flex: 1;
  padding: 2px;
`;
